const tileCarousels = document.querySelectorAll<HTMLElement>('.tile-carousel');

tileCarousels.forEach((slider) => {
	new (window as Window).Swiper(slider, {
		spaceBetween: 80,
		centeredSlides: true,
		centeredSlidesBounds: true,
		autoHeight: true,
		speed: 600,
		loop: true,
		breakpoints: {
			300: {
				slidesPerView: 1,
				navigation: {
					enabled: true,
					nextEl: slider.querySelector('.tile-carousel__button-next') as HTMLElement,
					prevEl: slider.querySelector('.tile-carousel__button-prev') as HTMLElement,
				},
			},
			768: {
				slidesPerView: 3,
				navigation: {
					enabled: true,
					nextEl: slider.querySelector('.tile-carousel__button-next') as HTMLElement,
					prevEl: slider.querySelector('.tile-carousel__button-prev') as HTMLElement,
				},
			},
		},
	});

	window.addEventListener('resize', function () {
		if (slider) {
			const firstSlide = slider.querySelector('.swiper-slide') as HTMLElement | null;
			if (firstSlide) {
				const firstSlideWidth = firstSlide.offsetWidth;
				const buttonWrappers = slider.querySelectorAll('.tile-carousel__button--wrapper');
				buttonWrappers.forEach((buttonWrapper) => {
					if (buttonWrapper instanceof HTMLElement) {
						buttonWrapper.style.height = `${firstSlideWidth}px`;
					}
				});
			}
		}
	});

	// Trigger the resize event once initially to set the correct heights
	window.dispatchEvent(new Event('resize'));
});
